import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleHeart } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden px-6 py-14 bg-[#0a0a0a]" data-id="element-146">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-rose/10 rounded-full blur-[120px] pointer-events-none" data-id="element-147" />

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-148">
        <FadeIn delay={0.1} data-id="element-149">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-gray/50 border border-brand-rose/20 text-brand-rose text-sm font-medium mb-6" data-id="element-150">
            <MessageCircleHeart className="w-4 h-4" data-id="element-151" />
            <span data-id="element-152">El sistema psicológico de atracción</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-153">
          <h1 className="font-serif text-5xl md:text-7xl font-bold leading-tight mb-5" data-id="element-154">
            Nunca Más Te Dejan <br className="hidden md:block" data-id="element-155" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-rose to-rose-400 italic" data-id="element-156">
              en Visto
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-157">
          <div className="space-y-3 text-lg md:text-xl text-brand-lightGray mb-8 max-w-2xl mx-auto font-light" data-id="element-158">
            <p data-id="element-159">Hay un momento que duele más de lo que parece.</p>
            <p data-id="element-160">Le envías un mensaje… ves que lo leyó… y no responde.</p>
            <p data-id="element-161">Pasan minutos… horas… tal vez días.</p>
            <p className="text-brand-cream font-medium text-xl md:text-2xl mt-4" data-id="element-162">
              Y en tu cabeza solo hay una pregunta: <br data-id="element-163" />
              <span className="italic text-brand-rose" data-id="element-164">"¿Qué hice mal?"</span>
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-165">
          <a href="#pricing" className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-brand-rose text-white font-semibold rounded-full overflow-hidden transition-transform hover:scale-105 active:scale-95" data-id="element-166">
            <span className="relative z-10" data-id="element-167">Quiero Empezar Ahora</span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-168" />
          </a>
          <p className="mt-3 text-sm text-brand-lightGray" data-id="element-169">
            Acceso inmediato • 100% Práctico
          </p>
        </FadeIn>
      </div>
    </section>;
}